import { Note } from './note'
import { Owner } from './user'

export class FigureSimple {
  id: number
  title: string
}

export class Figure {
  id: number
  owner: Owner
  title: string
  description: string
  figure_pic: string
  notes: Note[]
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  is_mine: boolean
  created_at: string
  last_update: string
  time_since_creation: string
  privacy: string
}
